import { docHtml } from '../../lib/format.js'
import { exampleParams, fields, formPairs } from '../../lib/schema.js'

const Fez = window.Fez;
if (!Fez) throw new Error('fez runtime not loaded: load fez (window.Fez) before component modules');

// --- api-action ---
let __fez_component_0;
{
const AUTH = {
  public: { label: 'Public', text: 'No sign-in needed.', tone: 'success', icon: 'globe' },
  user: { label: 'Signed in', text: 'Any signed-in user (session cookie).', tone: 'accent', icon: 'user' },
  admin: { label: 'Admin', text: 'System admin browser session only.', tone: 'warning', icon: 'shield-check' },
}

const TABS = [
  { id: 'json', label: 'curl (JSON)' },
  { id: 'form', label: 'curl (form)' },
  { id: 'js', label: 'JavaScript' },
]
__fez_component_0 = class {
  PROPS = {
    action: { type: Object, required: true },
    defs: Object,
  }

  init() {
    this.state.tab = 'json'
    this.state.tabs = TABS
  }

  show(tab) {
    this.state.tab = tab
  }

  beforeRender() {
    const action = this.props.action
    const defs = this.props.defs
    const origin = window.location.origin
    const path = action.path.replace('{ref}', action.ref_example)
    const params = exampleParams(action.params, defs)
    const json = JSON.stringify(params)
    const bearer = action.auth === 'public' ? [] : ['  -H "Authorization: Bearer $TOKEN"']
    const curl = (lines) => [`curl -X POST ${origin}/api/${path}`, ...bearer, ...lines].join(' \\\n')
    const quote = (value) => `'${String(value).replace(/'/g, "'\\''")}'`

    this.state.auth = AUTH[action.auth] || AUTH.user
    this.state.doc = docHtml(action.doc)
    this.state.fields = fields(action.params, defs)
    this.state.url = `/api/${action.path}`
    this.state.examples = {
      json: curl(['  -H "Content-Type: application/json"', `  -d ${quote(json)}`]),
      form: curl(formPairs(params).map(([key, value]) => `  -d ${key}=${quote(value)}`)),
      js: [
        `const response = await fetch('${origin}/api/${path}', {`,
        "  method: 'POST',",
        '  headers: {',
        ...(action.auth === 'public' ? [] : ["    authorization: 'Bearer ' + token,"]),
        "    'content-type': 'application/json',",
        '  },',
        `  body: JSON.stringify(${json}),`,
        '})',
        'const { success, data, error } = await response.json()',
      ].join('\n'),
    }
    this.state.example = this.state.examples[this.state.tab]
  }

  CSS = `:fez {
display:block;.page{max-width:880px;padding:var(--space-10) var(--space-8) var(--space-12)}.crumb{color:var(--color-text-subtle);font-size:var(--text-xs);font-weight:var(--weight-bold);letter-spacing:0.06em;text-transform:uppercase}h1{display:flex;flex-wrap:wrap;align-items:center;gap:var(--space-3);margin-top:var(--space-2);font-size:var(--text-xl);code{font-size:var(--text-xl);overflow-wrap:anywhere}}.method{padding:3px var(--space-2);border-radius:var(--radius-sm);background:var(--color-success-soft);color:var(--color-success);font-size:var(--text-xs);font-weight:var(--weight-bold);letter-spacing:0.04em}.summary{margin-top:var(--space-3);font-size:var(--text-lg)}.doc{margin-top:var(--space-2);color:var(--color-text-muted);p + p{margin-top:var(--space-2)}code{padding:1px 5px;border-radius:var(--radius-sm);background:var(--color-code-bg);color:var(--color-code-text)}}.facts{display:flex;flex-wrap:wrap;align-items:center;gap:var(--space-2);margin-top:var(--space-4);color:var(--color-text-muted);font-size:var(--text-sm)}section{margin-top:var(--space-10);h2{margin-bottom:var(--space-3);font-size:var(--text-lg)}}.box{padding:0 var(--space-5)}.none{padding:var(--space-4) 0;color:var(--color-text-muted);font-size:var(--text-sm)}.examples-tabs{margin-bottom:var(--space-3)}
}`

  HTML = `<div class="page">
<div class="crumb">{props.action.group}</div>
<h1><span class="method">POST</span><code>{state.url}</code></h1>
<p class="summary">{props.action.summary}</p>
{#if state.doc}
<div class="doc">{@html state.doc}</div>
{/if}
<div class="facts">
<ui-badge tone={state.auth.tone} icon={state.auth.icon} label={state.auth.label}></ui-badge>
<span>{state.auth.text}</span>
{#if props.action.ref_type}
<ui-badge label="ref: {props.action.ref_type}"></ui-badge>
{/if}
</div>

<section>
<h2>Params</h2>
<ui-card padding="none">
<div class="box">
{#if state.fields.length}
<api-schema :schema="props.action.params" :defs="props.defs"></api-schema>
{:else}
<p class="none">This action takes no params.</p>
{/if}
</div>
</ui-card>
</section>

<section>
<h2>Returns</h2>
<ui-card padding="none">
<div class="box">
<api-schema :schema="props.action.output" :defs="props.defs"></api-schema>
</div>
</ui-card>
</section>

<section>
<h2>Example</h2>
<div class="examples-tabs">
<ui-segmented label="Example" :options="state.tabs" value={state.tab} :onchange="(id) => fez.show(id)"></ui-segmented>
</div>
<ui-copy multiline value={state.example}></ui-copy>
</section>

<section>
<h2>Try it</h2>
<api-try :action="props.action" :defs="props.defs"></api-try>
</section>
</div>`
};
}

Fez('api-action', __fez_component_0);

export default __fez_component_0;
